import { setError, startSpinner, stopSpinner } from '../../actions/common/actionCreators';
import endpoints from '../../constants/configs/endpoints';
import API from '../../services/API';
import {
    IResetPasswordResponse,
    IResetPasswordValidateResponse,
    IResetPasswordSubmitEmailResponse,
} from '../../modules/resetPassword/common/types';

const actions = { setError, startSpinner, stopSpinner };

export const getPasswordResetQuestions = async (
    dispatch,
    encHHId,
): Promise<{
    isSuccess: boolean;
    isError: boolean;
    data: IResetPasswordResponse['data'] | null;
    error: any;
}> => {
    const url = endpoints.RESET_PASSWORD_GET_QUESTIONS.processReplacements({ encHHId });
    try {
        const data: IResetPasswordResponse = await API.getData(url, dispatch, actions, true);
        if (data?.data) {
            return { isSuccess: true, isError: false, data: data?.data, error: null };
        } else {
            return { isSuccess: false, isError: true, data: null, error: 'Something went wrong!' };
        }
    } catch (error) {
        console.error('Cannot get reset password questions', url, error);
        return { isSuccess: false, isError: true, data: null, error };
    }
};

export const validateResetPasswordQuestions = async (
    dispatch,
    payload,
): Promise<{
    isSuccess: boolean;
    isError: boolean;
    data: IResetPasswordValidateResponse | null;
    error: any;
}> => {
    const { encHHId, answers } = payload;
    const url = endpoints.RESET_PASSWORD_VALIDATE_QUESTIONS.processReplacements({ encHHId });
    const params = [url, answers, 'POST', true, undefined];
    try {
        const data: IResetPasswordValidateResponse = await API.postData(params, dispatch, actions, true);
        return { isSuccess: true, isError: false, data, error: null };
    } catch (error) {
        console.error('Cannot validate reset password questions', url, error);
        return { isSuccess: false, isError: true, data: null, error };
    }
};

export const sendResetPasswordEmail = async (
    dispatch,
    payload,
): Promise<{
    isSuccess: boolean;
    isError: boolean;
    data: IResetPasswordSubmitEmailResponse | null;
    error: any;
}> => {
    const { encHHId, emailPayload } = payload;
    const url = endpoints.RESET_PASSWORD_SET_EMAIL.processReplacements({ encHHId });
    const params = [url, emailPayload, 'POST', true, undefined];
    try {
        const data: IResetPasswordSubmitEmailResponse = await API.postData(params, dispatch, actions, true);
        return { isSuccess: true, isError: false, data, error: null };
    } catch (error) {
        console.error('Cannot send reset password email', url, error);
        return { isSuccess: false, isError: true, data: null, error };
    }
};
